module.exports = __webpack_public_path__ + "img/feitian.a1aba2d4.png";